import { createStyles } from '@mantine/emotion';
import { HEADER_HEIGHT } from '@components/header/constants';

export const useStyles = createStyles((theme, _, utils) => ({
  container: {
    height: '100%',
    width: `calc(100% - 580px)`,
    backgroundColor: theme.colors.backgroundGray[0],
    padding: `${theme.spacing.md} ${theme.spacing.sm} ${theme.spacing.md} ${theme.spacing.sm}`,
    margin: '0 auto',
    [utils.smallerThan('lg')]: {
      width: '100%'
    },
    [utils.smallerThan('md')]: {
      padding: '16px'
    },
    [utils.largerThan('md')]: {
      marginRight: 290
    },
    [utils.largerThan('lg')]: {
      marginLeft: 290
    }
  },

  fakeNavbar: {
    width: '290px',
    [utils.smallerThan('lg')]: {
      display: 'none'
    }
  },
  simpleNavbar: {
    position: 'fixed',
    right: 0,
    left: 'auto',
    backgroundColor: theme.colors.backgroundGray[0],
    '@media (max-width: 992px)': {
      display: 'none',
      width: '0'
    }
  },

  errorContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    backgroundColor: theme.colors.backgroundGray[0],
    height: `calc(100vh - ${HEADER_HEIGHT}px)`
  },

  box: {
    padding: '40px 32px 32px',
    [utils.smallerThan('xs')]: {
      padding: '16px'
    },
    margin: '100px  auto auto auto',
    width: '540px',
    maxWidth: `calc(100% - 20px)`
  }
}));
